<template>
  <div>
    <div class="columns">
      <div class="column is-four-fifths-desktop is-four-fifths-tablet is-full-mobile">
        <p id="back-to-results" class="is-size-7">
          <a href="javascript:void(0);" @click="showReviewerList" class="color-2aabe1"><i class="fas fa-arrow-left"></i> BACK TO REVIEWERS LISTING</a>
        </p>
      </div>
    </div>

    <div class="m-l-12">
      <div class="columns is-multiline" v-if="!fetching_data">
        <div class="column is-full-mobile padding-bottom-0 name-head">
          <div class="title is-marginless is-paddingless">
            {{ reviewerDetails.first_name + ' ' + reviewerDetails.last_name }}
            <a href="javascript:void(0)" class="link" @click="user.isEditing = true" v-if="!user.isEditing">Edit user</a>
            <a href="javascript:void(0)" class="link" @click="cancelEditing" v-else>Cancel</a>
          </div>
        </div>
        <!-- delete reviewer profile  -->
        <div class="buttons">
          <span class="button" :class="[{'is-button-dark-blue-outline': reviewerLogDetails.length<1}]" @click="showReviewerDeleteDialog" v-if="reviewerDetails.status === 'ACTIVE'">DELETE USER</span>
          <span data-track="Admin - User Reactivation Button" class="button is-uppercase is-button-dark-blue" :class="[{'is-loading': loaders.isReactivating}]" @click="handleUserReactivation" v-if="reviewerDetails.status === 'DELETED'">Reactivate User</span>
          <span class="button is-uppercase is-button-dark-blue" :disabled="!formCompleted" @click="saveChanges" v-if="user.isEditing">Save Changes</span>
        </div>
      </div>

      <div v-if="reviewerLogDetails && !fetching_data" class="review-detail is-italic">
          <ul>
              <li v-for="(reviewerLog, index) in reviewerLogDetails" :key="index">
                  <small v-if="getLogVal(reviewerLog.update_info)"> User and reviews deleted on {{ reviewerLog.created_at | reviewersLogDate }} by {{getFullName(reviewerLog)}}
                  </small>
                  <small v-if="!getLogVal(reviewerLog.update_info) && reviewerLog.action !== 'reviewer.admin.reactivated'">User deleted on {{ reviewerLog.created_at | reviewersLogDate }} by {{getFullName(reviewerLog)}}
                  </small>
                  <small v-if="reviewerLog.action === 'reviewer.admin.reactivated'">User reactivated on {{ reviewerLog.created_at | reviewersLogDate }} by {{getFullName(reviewerLog)}}
                  </small>
              </li>
          </ul>
      </div>

      <div class="columns is-paddingless is-marginless">
        <div class="column is-paddingless">
          <div class="card no-shadow">
            <strong class="is-size-6">Personal information</strong>
            <div class="card-content p-x-0 p-t-12">
              <div class="content" v-if="!fetching_data">
                <div class="row is-clearfix">
                  <div class="col is-pulled-left is-clearfix is-flex flex-align-centre">
                    <div class="is-size-7 has-text-grey is-pulled-left">First name</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left" v-if="!user.isEditing">{{reviewerDetails.first_name}}</div>
                    <input type="text" v-model="reviewerDetails.first_name" class="text-input" v-else>
                  </div>
                  <div class="col is-pulled-left is-clearfix is-flex flex-align-centre">
                    <div class="is-size-7 has-text-grey is-pulled-left">Email address</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left" v-if="!user.isEditing">{{reviewerDetails.email}}</div>
                     <input type="text" v-model="reviewerDetails.email" class="text-input" v-else>
                  </div>
                  <div class="col is-pulled-left is-clearfix">
                    <div class="is-size-7 has-text-grey is-pulled-left">ID number</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">1234567890{{reviewerDetails.id_number}}</div>
                  </div>
                </div>

                <div class="row is-clearfix">
                  <div class="col is-pulled-left is-clearfix is-flex flex-align-centre">
                    <div class="is-size-7 has-text-grey is-pulled-left">Last name</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left" v-if="!user.isEditing">{{reviewerDetails.last_name}}</div>
                    <input type="text" v-model="reviewerDetails.last_name" class="text-input" v-else>
                  </div>
                  <div class="col is-pulled-left is-clearfix is-flex flex-align-centre">
                    <div class="is-size-7 has-text-grey is-pulled-left">Mobile number</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left" v-if="!user.isEditing">{{reviewerDetails.phone}}</div>
                    <input type="text" v-model="reviewerDetails.phone" class="text-input" v-else>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-paddingless is-marginless">
        <div class="column is-paddingless">
          <div class="card no-shadow">
            <strong class="is-size-6">Account information</strong>
            <div class="card-content p-x-0 p-t-12">
              <div class="content" v-if="!fetching_data">
                <div class="row is-clearfix">
                  <div class="col is-pulled-left is-clearfix">
                    <div class="is-size-7 has-text-grey is-pulled-left">Registration date</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{reviewerDetails.created_at | prettyDate}}</div>
                  </div>
                  <div class="col is-pulled-left is-clearfix">
                    <div class="is-size-7 has-text-grey is-pulled-left">Last login date</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">
                      <span v-if="reviewerDetails.last_logged_in">{{reviewerDetails.last_logged_in | prettyDate}}</span>
                      <span v-else>N/A</span>
                    </div>
                  </div>
                </div>

                <div class="row is-clearfix">
                  <div class="col is-pulled-left is-clearfix">
                    <div class="is-size-7 has-text-grey is-pulled-left">Type of registration</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">
                      <span v-if="reviewerDetails.provider && reviewerDetails.provider_id">{{ reviewerDetails.provider }}</span>
                      <span v-else>Registration form</span>
                    </div>
                  </div>
                  <div class="col is-pulled-left is-clearfix">
                    <div class="is-size-7 has-text-grey is-pulled-left">Last review date</div>
                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{reviewerDetails.last_review_date | prettyDate}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-paddingless is-marginless">
        <div class="column padding-left-0 padding-top-0 padding-right-0">
          <div class="card no-shadow">
            <strong class="is-size-6">Reviews</strong>
            <div class="card-content p-x-0 p-t-12">
              <div class="columns" v-if="!fetching_data">
                <div class="column is-paddingless is-inline-flex flex-align-centre">
                  <div class="column is-narrow">
                    <div class="has-text-left">
                      <h3 class="has-text-grey is-size-7">{{ total_records + ' results' }}</h3>
                    </div>
                  </div>
                  <div class="column is-narrow">
                    <h3 class="has-text-grey is-size-7">{{reviews.length}} Selected</h3>
                  </div>
                </div>
                <!-- Action Button Begins -->
                <div class="column is-inline-flex flex-justify-end flex-align-start is-paddingless">
                  <div class="column is-narrow padding-top-0">
                    <button data-track="Portal-Admin - Delete Admin Businesses Reviews" class="button is-button-dark-blue-outline is-uppercase" :class="[{'is-loading': loaders.isDeleting}]" :disabled="!reviews.length || loaders.isDeleting" @click="actionHandler('delete')">
                      {{ !loaders.isDeleting ? 'Delete' : '' }}
                    </button>
                  </div>
                  <div class="column is-narrow padding-top-0 padding-right-0">
                    <button data-track="Portal-Admin - Republish Admin Businesses Reviews Lists" class="button is-button-dark-blue is-uppercase" :class="[{'is-loading': loaders.isRepublishing}]" :disabled="!reviews.length || loaders.isRepublishing" @click="actionHandler('republish')">
                      {{ !loaders.isRepublishing ? 'Re - publish' : '' }}
                    </button>
                  </div>
                </div> <!-- Action Button Ends -->
              </div>
              <div class="content">
                <div class="column is-paddingless">
                  <table class="table is-fullwidth transparent-table">
                    <thead>
                    <tr>
                      <td class="pad35-desktop is-desktop is-size-7 has-text-weight-bold has-text-grey is-narrow checkbox-field">
                        <label class="checkbox is-size-6 label-filters">
                          <input
                            data-track="Portal-Admin - Check Admin Businesses Reviews List"
                            type="checkbox"
                            class=""
                            :checked="reviewsCollection && (reviewsCollection.reviewIds.length === reviews.length)"
                            @change="checkAllReviews"
                          >
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="is-size-7 has-text-weight-bold has-text-grey is-narrow">Date published</td>
                      <td class="is-size-7 has-text-weight-bold has-text-grey biz-column">Business</td>
                      <td class="is-size-7 has-text-weight-bold has-text-grey title-column">Title</td>
                      <td class="is-size-7 has-text-weight-bold has-text-grey is-narrow">Star Rating</td>
                      <td class="is-size-7 has-text-weight-bold has-text-grey is-narrow">Status</td>
                      <td class="is-size-7 has-text-weight-bold has-text-grey is-narrow">&nbsp;</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                      <td class="is-size-7-mobile is-size-7-touch is-narrow checkbox-field">
                        <label class="checkbox is-size-6 label-filters">
                          <input
                            type="checkbox"
                            data-track="Portal-Admin - Check Admin Businesses Review from List"
                            :value="item.id"
                            :checked="reviews.includes(item.id)"
                            @change="handleCheckboxChange"
                          >
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="is-size-7 is-narrow">{{ item.created_at | prettyDate }}</td>
                      <td class="is-size-7 biz-column" @click="showReviewDetail(item)"><span>{{ asText(item.business.name, 80) }}</span></td>
                      <td class="is-size-7 title-column" @click="showReviewDetail(item)">{{ asText(item.review_title, 100) }}</td>
                      <td class="is-size-7 is-narrow star-rating-icons"><rating :stars="item.review_rating" :setRatingContWidth="ratingWidth"></rating></td>
                      <td class="is-size-7 is-narrow">
                        <span v-if="item.status_id === 1">Active</span>
                        <span v-else-if="item.status_id === 2">Deleted</span>
                      </td>
                      <td class="is-size-7-mobile is-size-7-touch is-narrow">
                        <span v-if="item.replied" class="tag is-private is-rounded has-text-weight-bold">Replied</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <table v-if="!fetching_reviews && items.length === 0"
                         class="table is-fullwidth has-vertically-aligned-content">
                    <tbody>
                    <tr>
                      <td class="is-narrow">
                        <p class="is-size-7 has-text-weight-bold has-text-grey has-text-centered">No reviews found for this reviewer.</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- paginator -->
              <paginator :dataSet="dataSet" @changed="getReviewerReviews"></paginator>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- review delete modal -->
    <div class="modal is-active" v-if="deleteReviewStatus">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head headnewcl">
          <strong>Delete reviewer</strong>
          <p class="head-text">You're about to delete {{getReviewerName}} - {{getReviewerEmail}}</p>
          <p>Why is this reviewer being deleted?</p>

        </header>

        <section class="modal-card-body">

          <div>
            <textarea ref="bizReason"  maxlength="350" rows="6" class="delete-reason " v-model="deleteReviewerReason"></textarea>
          </div>

          <div class="notify-check-section">
            <label class="label is-size-7">
              <input
                      type="checkbox"
                      name="notifyCheck"
                      ref="notifyCheck"
                      v-model="notifyCheck"
              />
              &nbsp; Delete all reviews posted by this user: {{total_records}} reviews
            </label>
          </div>
          <!-- Content ... -->
        </section>

        <footer class="modal-card-foot delete-review-footer">

          <button class="button" @click="deleteReviewStatus=false">CANCEL</button>
          <button :disabled="checkReviewerStatus" class="button" @click="deleteReviewer">DELETE</button>
        </footer>
      </div>
    </div>
    <!-- Confirmation Modal -->
    <ModalPopup
      primaryBtnText="Cancel"
      :title="confirmationModal.title"
      :body="confirmationModal.body"
      :secondaryBtnText="confirmationModal.secondaryBtnText"
      :onBlur="stayOnPage"
      :primaryBtnAction="stayOnPage"
      :secondaryBtnAction="loaders.isDeleting ? handleMultiDelete : handleMultiRepublish"
    />
    <!-- Confirmation Modal -->
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc */
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import Rating from './../../components/Rating.vue'
  import {ModalPopup} from '@/components'
  import misc from '../../mixins/misc.js'
  import moment from 'moment'
  import { mapState, mapActions } from 'vuex'
  import { SHOW_MODAL } from '@/store/action.types'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Reviewer Details'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Users'
      })
    },
    components: {Paginator, Rating, ModalPopup},
    mixins: [misc],
    data () {
      return {
        fetching_data: false,
        fetching_reviews: true,
        reviewerDetails: null,
        reviewerDetailsCopy: null,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        notifyCheck: false,
        deleteReviewStatus: false,
        deleteReviewerReason: '',
        reviewerLogDetails: {},
        ratingWidth: true,
        reviews: [],
        user: {isEditing: false},
        reviewsCollection: null,
        loaders: {isDeleting: false, isExporting: false, isRepublishing: false, isReactivating: false},
        confirmationModal: {title: '', body: '', secondaryBtnText: '', secondaryBtnAction: null}
      }
    },
    created () {
      this.getReviewerDetails()
      this.getReviewerReviews(null)
      this.getReviewerLogList()
    },
    computed: {
      ...mapState({
        modal: state => state.app.modal
      }),
      // check whether reason provided or not
      checkReviewerStatus () {
        return !this.deleteReviewerReason
      },
      getReviewerName () {
        return `${this.reviewerDetails.first_name} ${this.reviewerDetails.last_name}`
      },
      getReviewerEmail () {
        return `${this.reviewerDetails.email}`
      },
      reviewerId () {
        return this.$router.currentRoute.params.reviewerId
      },
      reviewerListParam () {
        let reviewerListParam = localStorage.reviewerListParam
        if (reviewerListParam) {
          localStorage.removeItem('reviewerListParam')
          return JSON.parse(reviewerListParam)
        }
        return {status: '', page: 1}
      },
      formCompleted () {
        return this.reviewerDetails.first_name && this.reviewerDetails.phone && this.reviewerDetails.email
      }
    },
    methods: {
      ...mapActions({
        'showModal': `app/${SHOW_MODAL}`
      }),
      showReviewerList () {
        let url = `/users-list/reviewers?status=${encodeURIComponent(this.reviewerListParam.status)}&page=${this.reviewerListParam.page}`
        if ('keyword' in this.reviewerListParam) {
          url += `&keyword=${this.reviewerListParam.keyword}`
        }
        this.$router.push(url)
      },
      getLogVal (logVal) {
        if (logVal) {
          let parsedVal = JSON.parse(logVal)
          return parsedVal.userandreviews
        }
      },
      // get reviewer details
      getReviewerLogList () {
        this.fetching_data = true
        axios.get(`/users/reviewer/history/${this.reviewerId}`)
            .then((response) => {
              this.reviewerLogDetails = response.data
              this.fetching_data = false
            })
            .catch(() => {
              // flash('You are not authorized to view this resource.', 'is-danger')
              this.fetching_data = false
            })
      },
      // delete reviewer and his/her reviews
      deleteReviewer () {
        flash(`The user and reviews linked to ${this.reviewerDetails.email} have been successfully deleted.`, 'is-success')
        this.deleteReviewStatus = false
        let params = {
          notifyStatus: this.notifyCheck,
          deleteReviewerReason: this.deleteReviewerReason
        }
        axios.post(`/users/reviewer/delete/${this.reviewerId}`, params)
            .then((response) => {
              this.getReviewerLogList()
              this.getReviewerDetails()
              this.getReviewerReviews(1)
              this.notifyCheck = false
              this.deleteReviewerReason = ''
              this.deleteReviewStatus = false
              flash(`The user and reviews linked to ${this.reviewerDetails.email} have been successfully deleted.`, 'is-success')

              if (this.reviewerDetails.user_uuid) {
                this.recacheHomepage()
              }
            })
            .catch(() => {
              this.deleteReviewStatus = false
              flash(`There was an error deleting this reviewer. Please try again.`, 'is-danger')
            })
      },
      // show delete reviewer dialog
      showReviewerDeleteDialog () {
        this.deleteReviewStatus = true
      },
      preventClick (event) {
        event.stopPropagation()
      },
      /**
       * Goes to reported reviews page for choosen busines
       * @param {object} item Review slug
       * @returns {void}
       */
      gotoReviewerDetails (item) {
        this.$router.push(`/users-list/reviewers/${item.id}`)
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getReviewerDetails () {
        this.fetching_data = true
        axios.get(`/users/reviewer/${this.reviewerId}`)
            .then((response) => {
              this.reviewerDetails = this.reviewerDetailsCopy = response.data
              this.fetching_data = false
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
              this.fetching_data = false
            })
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getReviewerReviews (page) {
        this.page = page
        this.fetching_reviews = true
        axios.get(this.url(page))
            .then((response) => {
              this.reviewsCollection = response.data
              this.items = response.data.data
              response.data.data = undefined
              this.dataSet = response.data
              this.fetching_reviews = false
              this.total_records = response.data.total
            })
            .catch((error) => {
              console.log(error)
              flash('You are not authorized to view this resource.', 'is-danger')
              this.fetching_data = false
            })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @return {string}
       */
      url (page) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        return `/users/reviewer/reviews/${this.reviewerId}?page=${page}`
      },
      // show review detail
      showReviewDetail (item) {
        localStorage.removeItem('review_redirect')
        localStorage.removeItem('sweep')
        localStorage.setItem('user_profile_redirect', true)
        this.$router.push(`/business/${item.business.slug}/review/${item.permalink}/${item.id}`)
      },
      /**
       * Check mark all the reviews
       * @param {object} e
       * @returns {void}
       */
      checkAllReviews (e) {
        if (e.target.checked) {
          this.reviewsCollection.reviewIds.forEach((obj) => {
            if (!this.reviews.includes(parseInt(obj))) {
              this.reviews.push(parseInt(obj))
            }
          })
        } else {
          this.reviews = []
        }
      },
      /**
       * Handle checkbox change
       * @param {object} data
       * @returns {void}
       */
      handleCheckboxChange (event) {
        if (event.target.checked) {
          this.reviews.push(parseInt(event.target.value))
        } else {
          this.$delete(this.reviews, this.reviews.indexOf(parseInt(event.target.value)))
        }
      },
      /**
       * Handle modal as per action
       * @param {object} action
       * @return {void}
       */
      actionHandler (action) {
        this.showModal()
        if (action === 'delete') {
          this.loaders.isDeleting = true
          Object.assign(this.confirmationModal, {
            title: 'DELETE REVIEWS?',
            body: `You're about to delete these reviews. If you proceed they will be removed from the Businesses public account.`,
            secondaryBtnText: 'Delete Reviews'
          })
        } else if (action === 'republish') {
          this.loaders.isRepublishing = true
          Object.assign(this.confirmationModal, {
            title: 'RE-PUBLISH REVIEWS?',
            body: `You're about to re-publish these reviews. If you proceed they will be visible on the Businesses public account.`,
            secondaryBtnText: 'Re-publish Reviews'
          })
        }
      },
      /**
       * Handle Multiple Review Deletion
       * @return {void}
       */
      handleMultiDelete () {
        this.showModal(false)
        axios.post(`${this.getBusinessSlug}/reviews/delete`, {
          reviews: this.reviews
        })
        .then(({data}) => {
          this.reviews = []
          this.updatePageData(data, 'Portal - Admin | Multiple reviews delete successfully')
        })
        .catch((error) => {
          console.log(error)
          this.stayOnPage()
          flash(`${error.message}`, 'is-danger')
        })
      },
      /**
       * Handle Multiple Review Deletion
       * @return {void}
       */
      handleMultiRepublish () {
        this.showModal(false)
        axios.post(`${this.getBusinessSlug}/reviews/republish`, {
          reviews: this.reviews
        })
        .then(({data}) => {
          this.reviews = []
          this.updatePageData(data, 'Portal - Admin | Multiple reviews republished successfully')
        })
        .catch((error) => {
          this.stayOnPage()
          console.log(error)
          flash(`${error.message}`, 'is-danger')
        })
      },
      /**
       * Refresh page data after handling any action
       * @return {void}
       */
      updatePageData (data, mssg = '') {
        this.stayOnPage()
        this.getReviewerReviews(null)
        this.displaySuccessMsg(`${data.message}`, mssg)
      },
      /**
       * Stay on the page and close modal when clicked on stay on this page
       * @return {void}
       */
      stayOnPage () {
        this.loaders.isDeleting = this.loaders.isRepublishing = false
        this.showModal(false)
      },
      /**
       * Handle when user is reactivated
       * @return {void}
       */
      handleUserReactivation () {
        this.loaders.isReactivating = true
        axios.put(`admin/users/${this.reviewerId}`)
        .then(({data}) => {
          this.loaders.isReactivating = false
          this.getReviewerDetails()
          this.getReviewerLogList()
          this.displaySuccessMsg(data.message, 'Portal - Admin | User reactivated successfully')
        })
        .catch((error) => {
          console.log(error)
          flash(`${error.message}`, 'is-danger')
        })
      },
      /**
       * Cancel editing for user
       * @returns {void}
       */
      cancelEditing () {
        this.user.isEditing = false
        Object.assign(this.reviewerDetails, this.reviewerDetailsCopy)
      },
      /**
       * Save changes for user
       * @returns {void}
       */
      saveChanges () {
        if (!this.formCompleted) {
          return
        }
        axios.put(`admin/user/${this.reviewerId}/update-profile`, {
          email: this.reviewerDetails.email,
          mobile: this.reviewerDetails.phone,
          last_name: this.reviewerDetails.last_name,
          first_name: this.reviewerDetails.first_name
        })
        .then(({data}) => {
          this.user.isEditing = false
          Object.assign(this.reviewerDetails, data.data)
          Object.assign(this.reviewerDetailsCopy, data.data)
          this.displaySuccessMsg(`${data.message}`, 'Portal - Admin | User Details Successfully')
        })
        .catch(({response}) => {
          Object.keys(response.data).forEach((key) => {
            flash(response.data[key][0], 'is-danger')
          })
        })
      }
    },
    filters: {
      prettyDate (date) {
        if (date === null) return 'N/A'
        return moment(date).format('DD-MM-YYYY')
      },
      reviewersLogDate (date) {
        return moment(date).format('DD-MM-YYYY HH:mm')
      }
    }
  }
</script>

<style scoped>
  .table td, .table th {
    border: none;
  }

  .table > tbody > tr {
    background-color: #f5f5f5 !important;
    margin-bottom: 10px;
  }

  .table > tbody > td {
    margin-bottom: 20px;
  }

  tbody tr {
    cursor: pointer;
  }

  .tag.is-private {
    background-color: #c4cbd1;
    color: #58595b;
    font-size: 0.65rem;
  }
  .table td, .table th {
    padding: 0.7rem 0.75em 0.1em !important;
  }

  .delete-reason{
    width: 100% !important;
    resize: none;
    padding: 10px;
    font-size: .85em !important;
    color: #8a8c91;
  }
  .modal-card-foot > button{
    float: right;
  }
  .modal-card-body {
    padding-top: 0px;
  }
  .headnewcl{
    flex-direction:column;
  }
  .headnewcl p{
    text-align:left;    display: block;
    width: 100%;
  }

  .delete-review button{
    margin-top:10px;
    padding: 4px;
    border-radius: 5px;
  }
  .delete-review-footer{
    display: flex;
    justify-content: flex-end;
  }
  .modal-card-head {
    border-top: 5px solid #30AAE1;
    padding-top: 40px;
    border-bottom: none !important;
    background-color: #fff;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    padding-bottom: 7px;
  }
  .modal-card-foot {
    border-top: none !important;
    background-color: #fff;
    border-radius: none !important;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  .notify-check-section {
    margin-top: 13px;
    margin-bottom: 10px;
  }
  textarea {
    font-size: .85em !important;
  }
  textarea.is-danger {
    border-color: #ff3860;
  }
  .headnewcl p.head-text {
    text-align: center !important;
    margin: 10px 10px;
  }
  .review-detail {
      font-size: 0.875em;
      padding-bottom: 13px;
      margin-left: 2px;
  }
  .name-head {
    padding-left: 0 !important;
  }
  .isBtnDiabled {
    pointer-events:none;
    opacity: 0.5;
  }

  .biz-column {
    width: 30% !important;
    word-break: break-word;
  }
  .title-column {
    width: 40% !important;
    word-break: break-word;
  }
  .button {
    width: 105px;
    height: 35px;
    font-size: 10px;
  }
  .table td.checkbox-field, .table th.checkbox-field {
    padding: 0.5rem 0.75em !important;
  }
  .table td.star-rating-icons {
    padding: 0.35rem 0.75em 0.1em !important;
  }

  /* Edit user details CSS Begins */
  .link {
    color: #30aae1;
    font-size: 10px;
    font-weight: normal;
    text-decoration: underline;
  }
  .text-input {
    padding: 4px 8px;
    border: solid 1px rgba(88, 89, 91, 0.32);
    background-color: #ffffff;
  }
  .card-content .content .is-clearfix {
    margin: 0 0 3px 0;
  }
  .button[disabled], .button[disabled]:hover {
    color: #cdcbcb !important;
    border: solid 1px #cdcbcb;
    background: #ffffff !important;
  }
  /* Edit user details CSS Ends */

  /* Create a custom checkbox Begins */
  .label-filters input[type="checkbox"] {
    visibility: hidden;
  }
  .checkmark {
    position: absolute;
    top: 4px;
    left: 0;
    height: 16px;
    width: 16px;
    background-color: #fff;
    border: solid 1px #707070;
  }
  /* On mouse-over, add a grey background color */
  .label-filters:hover input ~ .checkmark {
    background-color: #fff;
  }
  /* When the checkbox is checked, add a blue background */
  .label-filters input:checked ~ .checkmark {
    border: none;
    background-color: #30aae1;
  }
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  /* Show the checkmark when checked */
  .label-filters input:checked ~ .checkmark:after {
    display: block;
  }
  /* Style the checkmark/indicator */
  .label-filters .checkmark:after {
    left: 5px;
    top: 3px;
    width: 5px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  /* Create a custom checkbox Ends */
</style>



// WEBPACK FOOTER //
// src/pages/users/ReviewerDetails.vue